export default "__VITE_ASSET__39a8bc1b__"